import { useState, useEffect } from "react";

import EstudianteLista from "../components/estudiantes/EstudianteLista";
import useToken from "../components/login/useToken";
import NuevoEstudiante from "../components/estudiantes/EstudianteNuevo";
import Backdrop from "../components/layout/backdrop";
import DescuentoEstudiante from "../components/estudiantes/EstudianteDescuento";
import NuevoIngreso from "../components/Ingresos/IngresoNuevo";
import SubMenuEstudiantes from "../components/estudiantes/SubMenuEstudiantes";
import EliminaEstudiante from "../components/estudiantes/EstudianteElimina";
import EditaEstudiante from "../components/estudiantes/EstudianteEdicion";
import MenuFiltraEstudiantes from "../components/estudiantes/EstudianteFiltroMenu";
import MenuOrdenaEstudiantes from "../components/estudiantes/EstudianteOrdenaMenu";
import PagosEstudiante from "../components/Ingresos/PagosEstudiante";
import CambiaHabitacion from "../components/habitaciones/HabitacionCambia";
import OKModal from "../components/dialogos/dialogoOK";
import Reactivaestudiante from "../components/estudiantes/EstudianteReactiva";
import AdeudoEstudiante from "../components/estudiantes/EstudianteAdeudo";
import ListaNegra from "../components/estudiantes/EstudianteListaNegra";
import { EnviaDatosANuevoServicio } from "../Funciones/Funciones";
import RecordatorioEstudiante from "../components/estudiantes/EstudianteRecordatorio";

function TodosLosEstudiantesPage(props) {
  const [isLoading, setIsLoading] = useState(true);
  const [loadedEstudiantes, setLoadedEstudiantes] = useState([]);
  const [mostrarNuevo, setMostrarNuevo] = useState(false);
  const [mostrarDescuentos, setMostrarDescuentos] = useState(false);
  const [mostrarPago, setMostrarPago] = useState(false);
  const [mostrarEdicion, setMostrarEdicion] = useState(false);
  const [estudiante, setEstudiante] = useState([]);
  const [muestraSubMenu, setMuestraSubMenu] = useState(false);
  const [posicionSubMenu, setPosicionSubMenu] = useState([]);
  const [mostrarElimina, setMostrarElimina] = useState(false);
  const [muestraFiltroEst, setMuestraFiltroEst] = useState(false);
  const [posFiltroEstudiantes, setPosFiltroEstudiantes] = useState([]);
  const [filtroEstudiantes, setFiltroEstudiantes] = useState({
    conAdeudo: true,
    sinAdeudo: true,
    porNombre: "",
    porHabitacion: "",
  });
  const [muestraOrdenaEst, setMuestraOrdenaEst] = useState(false);
  const [posOrdenaEstudiantes, setPosOrdenaEstudiantes] = useState([]);
  const [ordenaEstudiantes, setOrdenaEstudiantes] = useState({
    NombreAZ: false,
    NombreZA: false,
    HabAZ: true,
    HabZA: false,
    AdeudaAZ: false,
    AdeudaZA: false,
  });
  const [mostrarPagosEstudiante, setMostrarPagosEstudiante] = useState(false);
  const [datosPagosEstudiante, setDatosPagosEstudiante] = useState({});
  const [mostrarCambiaHabitacion, setMostrarCambiaHabitacion] = useState(false);
  const [datosCambiaHabitacion, setDatosCambiaHabitacion] = useState({});
  const [borrado, setBorrado] = useState(false);
  const [recargaFoto, setRecargaFoto] = useState(false);
  const { token } = useToken();
  const [dialogoOK, setDialogoOK] = useState({
    texto: "",
    mostrandoError: false,
    recargar: false,
    cerrarVentana: "",
  });
  const [muestraDialogoOK, setMuestraDialogoOK] = useState(false);
  const [recargar, setRecargar] = useState(false);
  const [muestraReactivaEstudiante, setMuestraReactivaEstudiante] =
    useState(false);
  const [muestraAdeudo, setMuestraAdeudo] = useState(false);
  const [datosPopAdeudo, setDatosPopAdeudo] = useState([]);
  const [muestraListaNegra, setMuestraListaNegra] = useState(false);
  const idUsu = token.Id;
  const [datosRecordatorio, setDatosRecordatorio] = useState([]);
  const [mostrarAgregarRecordatorio, setMostrarAgregaRecordatorio] =
    useState(false);

  //console.log("TodoslosEst",props);
  function preparaAdeudo(datosAdeudo) {
    setDatosPopAdeudo(datosAdeudo);
    setMuestraAdeudo(true);
  }

  function palomeaOK() {
    setMuestraDialogoOK(false);
    if (!dialogoOK.mostrandoError) {
      if (dialogoOK.cerrarVentana === "mostrarDescuentos")
        setMostrarDescuentos(false);
      if (dialogoOK.cerrarVentana === "mostrarEdicion")
        setMostrarEdicion(false);
      if (dialogoOK.cerrarVentana === "mostrarElimina")
        setMostrarElimina(false);
      if (dialogoOK.cerrarVentana === "NuevoEstudiante") setMostrarNuevo(false);
      if (dialogoOK.cerrarVentana === "cambiaHabitacion")
        setMostrarCambiaHabitacion(false);
      if (dialogoOK.cerrarVentana === "pagoNuevo") setMostrarPago(false);
      if (dialogoOK.cerrarVentana === "ReactivaEstudiante")
        setMuestraReactivaEstudiante(false);
      if (dialogoOK.recargar) {
        setRecargar(true);
        props.setRecargar(true);
        setDialogoOK({ recargar: false });
      }
    }
  }

  //console.log("filtroEstudiantes", filtroEstudiantes);
  function PagoCompletado() {
    setMostrarNuevo(false);
    setBorrado(true);
    setRecargar(true);
    if (props.setRecargar !== undefined) {
      props.setRecargar(true);
    }
  }

  function EliminadoOK() {
    setMostrarElimina(false);
    setBorrado(true);
  }
  function AgregaEstudiante() {
    setMostrarNuevo(true);
  }

  function ReactivaEstudiante() {
    setMuestraReactivaEstudiante(true);
  }

  function QueEstudiantesMandar(estudiante) {
    if (props?.muestra !== "Adeudo") {
      //Aqui entramos si no estamos en la pantalla de inicio
      //Si no esta definido el filto de estudiantes, incluye al estudiante
      if (!filtroEstudiantes) return true;
      //Si hay algo en filtro por habitacion
      if (filtroEstudiantes.porHabitacion !== "") {
        //Si la habitacion del estudiante no incluye algo de lo indicado en el filtro no incluye al estudiante
        if (
          estudiante.Habitacion.toUpperCase().indexOf(
            filtroEstudiantes.porHabitacion.toUpperCase(),
          ) < 0
        ) {
          return false;
        }
      }
      //Si hay algo en el filtro por nombre
      if (filtroEstudiantes.porNombre !== "") {
        //si el nombre del estudiante no incluye algo de lo indicado en el filtro, no incluye al estudiante
        if (
          estudiante.Nombre.toUpperCase().indexOf(
            filtroEstudiantes.porNombre.toUpperCase(),
          ) < 0
        ) {
          return false;
        }
      }
      //console.log(filtroEstudiantes.conAdeudo, filtroEstudiantes.sinAdeudo, estudiante.MesQPag)
      if (estudiante.MesQPag !== undefined) {
        return filtroEstudiantes.conAdeudo;
      } else {
        return filtroEstudiantes.sinAdeudo;
      }
    }
    //aqui entra si estamos en la pantalla de inicio (inquilinos con adeudo)
    //debe regresar todos porque ya estan filtrados desde backend
    return true;
  }

  function OrdenEstudiantes(a, b) {
    if (props.muestra === "Adeudo") {
      const adeudoA =
        a.MesQPag.substring(0, a.MesQPag.indexOf("(") - 1) +
        (a.DiaCorte.length === 1 ? +" " + a.DiaCorte : a.DiaCorte);
      const adeudoB =
        b.MesQPag.substring(0, b.MesQPag.indexOf("(") - 1) +
        (b.DiaCorte.length === 1 ? +" " + b.DiaCorte : b.DiaCorte);
      return parseInt(adeudoA) > parseInt(adeudoB) ? 1 : -1;
    }
    if (ordenaEstudiantes.NombreZA) return a.Nombre < b.Nombre ? 1 : -1;
    if (ordenaEstudiantes.HabAZ)
      return a.Habitacion.toUpperCase() > b.Habitacion.toUpperCase() ? 1 : -1;
    if (ordenaEstudiantes.HabZA)
      return a.Habitacion.toUpperCase() < b.Habitacion.toUpperCase() ? 1 : -1;
    if (ordenaEstudiantes.AdeudaAZ)
      return parseInt(TotalAdeudo(a)) > parseInt(TotalAdeudo(b)) ? 1 : -1;
    if (ordenaEstudiantes.AdeudaZA)
      return parseInt(TotalAdeudo(a)) < parseInt(TotalAdeudo(b)) ? 1 : -1;
    return a.Nombre > b.Nombre ? 1 : -1;
  }

  function TotalAdeudo(estudiante) {
    if (estudiante.MesQPag === undefined) return 0;
    if (estudiante.MesQPag === "0") return 0;
    //sacamos todos los adeudos. Viene como 202601 (3200), 202602 (3200). Puede solo tener 1 o varios meses en adeudo
    var Adeudos = estudiante.MesQPag.split(",");
    //los contamos
    const numAdeudos = Adeudos.length;

    var total = 0;
    //los recorremos
    for (var i = 0; i < numAdeudos; i++) {
      const MontoAdeudo = Adeudos[i].substring(
        Adeudos[i].indexOf("(") + 1,
        Adeudos[i].indexOf(")"),
      );
      //console.log(total, MontoAdeudo)
      total += parseInt(MontoAdeudo);
    }

    return total;
  }

  function FiltraEstudiantes(ev) {
    //console.log("ev", ev.target);
    setPosFiltroEstudiantes({
      x: ev.target.offsetLeft,
      y: ev.target.offsetTop + ev.target.offsetHeight,
    });
    setMuestraFiltroEst(true);
  }

  function OrdenaEstudiantes(ev) {
    setPosOrdenaEstudiantes({
      x: ev.target.offsetLeft,
      y: ev.target.offsetTop + ev.target.offsetHeight,
    });
    setMuestraOrdenaEst(true);
  }

  function AgregaDescuentoHandler(estudiante) {
    setEstudiante(estudiante);
    setMostrarDescuentos(true);
  }

  function setDatosSubMenu(datos) {
    setPosicionSubMenu({
      posX: datos.posX,
      posY: datos.posY,
    });
    setEstudiante(datos.estudiante);
  }

  function EditaEstudianteHandler(estudiante) {
    setEstudiante(estudiante);
    setMostrarEdicion(true);
  }

  function muestraPagosEstudiante(IDEst) {
    setMuestraSubMenu(false);
    const tempEst = loadedEstudiantes.find((est) => est.IDEst === IDEst);
    setDatosPagosEstudiante({
      IDEst: IDEst,
      DiaCorte: tempEst.DiaCorte,
      Nombre: tempEst.Nombre,
    });
    setMostrarPagosEstudiante(true);
  }

  function agregaRecordatorio(IDEst) {
    setMuestraSubMenu(false);
    const tempEst = loadedEstudiantes.find((est) => est.IDEst === IDEst);
    setDatosRecordatorio({ IDEst: IDEst, Nombre: tempEst.Nombre });
    setMostrarAgregaRecordatorio(true);
  }

  function cambiaHabitacion(IDEst) {
    setMuestraSubMenu(false);
    setDatosCambiaHabitacion({ IDEst: IDEst });
    setMostrarCambiaHabitacion(true);
  }

  function EliminaEstudianteHandler(estudiante) {
    setEstudiante(estudiante);
    setMostrarElimina(true);
  }

  function AgregaPagoHandler(estudiante) {
    fetch("https://www.copilco.net/inc/funciones.React.php", {
      method: "POST",
      body: JSON.stringify({
        accion: "DatosAltaIngreso",
        IDCasa: props.casaSel,
        IDEst: estudiante.IDEst,
      }),
      headers: {
        "content-type": "application/json",
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        //console.log(data);
        var datosNece = [];
        if (data.ERROR !== "SI") {
          for (const key in data) {
            const datos = {
              ...data[key],
            };
            if (key === "Habitaciones") {
              datosNece = Object.keys(datos).map((key) => datos[key]);
            }
          }
          if (!datosNece[0].MesQPag) {
            //si no hay mes de pago, o sea, no ha pagado nunca
            //ponemos el mes que entro como fecha de pago inicial
            datosNece[0].MesQPag = datosNece[0].FechaIng.slice(0, 6);
          }
          const estT = {
            ...estudiante,
            MesQPag: datosNece[0].MesQPag + " (" + datosNece[0].Precio + ")",
          };
          setEstudiante(estT);
          setMostrarPago(true);
        } else {
          console.log("ERROR", data.ERROR);
        }
      })
      .catch((ev) => {
        console.log("error TE", ev);
      });
  }

  function respServ(respuesta) {
    //console.log("resp",respuesta)
    if (respuesta.Error !== "SI") {
      const estudiantes = Object.keys(respuesta.Estudiantes).map(
        (key) => respuesta.Estudiantes[key],
      );
      setLoadedEstudiantes(estudiantes);
      /*
      if (props.muestra === "Adeudo") {
        const estudiantes = Object.keys(respuesta.Estudiantes).map((key) => respuesta.Estudiantes[key]);
        setLoadedEstudiantes(estudiantes.filter((Estudiante) => {
          return Estudiante.FormaPago !== undefined;
        }));
      }
      else {
        const estudiantes = Object.keys(respuesta.Estudiantes).map((key) => respuesta.Estudiantes[key]);
        setLoadedEstudiantes(estudiantes);
      }*/
    } else {
      alert(respuesta.DESCERROR);
    }
  }

  useEffect(() => {
    setMostrarEdicion(false);
    setMostrarCambiaHabitacion(false);
    setMostrarDescuentos(false);
    setMostrarElimina(false);
    setMostrarNuevo(false);
    setMostrarPago(false);
    setMostrarPagosEstudiante(false);
    setMuestraFiltroEst(false);
    setMuestraOrdenaEst(false);
    setMuestraReactivaEstudiante(false);
    setMuestraSubMenu(false);
    setMuestraDialogoOK(false);
    setMuestraAdeudo(false);
    setMostrarAgregaRecordatorio(false);
    //console.log(token)
    if (props.casaSel > 0) {
      setBorrado(false);
      setRecargar(false);
      setIsLoading(true);
      //console.log(props)
      const datos = {
        IDCasa: props.casaSel,
        Regresar: props.muestra,
      };
      EnviaDatosANuevoServicio(
        "DatosItemEstudiantes",
        datos,
        respServ,
        setIsLoading,
        null,
        idUsu,
      );
    } else {
      setIsLoading(false);
    }
  }, [token, borrado, recargar, props.casaSel, props.muestra, idUsu]);

  function recarga() {
    setMuestraSubMenu(false);
  }
  //console.log("recargafoto", recargaFoto, recargar);
  //console.log("loadedEstudiantes",loadedEstudiantes);
  /***********************************************************************/
  /************************ RENDER ***************************************/
  /***********************************************************************/
  if (isLoading) {
    return (
      <section>
        <h1>Cargando estudiantes...</h1>
        <h1>
          <i className="fas fa-spinner fa-spin"></i>
        </h1>
      </section>
    );
  }
  if (props.casaSel > 0 && loadedEstudiantes) {
    if (loadedEstudiantes.length > 0) {
      return (
        <section className="centrarElem">
          {props?.muestra !== "Adeudo" ? (
            <div className="TituloBoton">
              <h1 className="TitEst">Estudiantes</h1>
              <div className="contBotones">
                <button className="botAgregaEst" onClick={OrdenaEstudiantes}>
                  <i className="fas fa-sort-amount-up-alt"></i>
                </button>
                <button className="botAgregaEst" onClick={FiltraEstudiantes}>
                  <i className="fas fa-filter"></i>
                </button>
                {props.nivel === 1 ? (
                  <button className="botAgregaEst" onClick={AgregaEstudiante}>
                    <i className="fas fa-user-plus"></i>
                  </button>
                ) : null}
                {props.nivel === 1 ? (
                  <button className="botAgregaEst" onClick={ReactivaEstudiante}>
                    <i className="fas fa-users-cog"></i>
                  </button>
                ) : null}
                <button className="botAgregaEst" onClick={setMuestraListaNegra}>
                  <i className="fas fa-ban"></i>
                </button>
              </div>
            </div>
          ) : (
            <h1 className="TitEst">Estudiantes con adeudo</h1>
          )}
          {loadedEstudiantes.filter((estudiante) =>
            QueEstudiantesMandar(estudiante),
          ).length === 0 && <h1>Sin Estudiantes por Filtro</h1>}
          <EstudianteLista
            AgregaPagoHandler={AgregaPagoHandler}
            AgregaDescuentoHandler={AgregaDescuentoHandler}
            setMuestraSubMenu={setMuestraSubMenu}
            setDatosSubMenu={setDatosSubMenu}
            EliminaEstudianteHandler={EliminaEstudianteHandler}
            EditaEstudianteHandler={EditaEstudianteHandler}
            estudiantes={loadedEstudiantes
              .filter((estudiante) => QueEstudiantesMandar(estudiante))
              .sort((a, b) => OrdenEstudiantes(a, b))}
            recargaFoto={recargaFoto}
            setRecargaFoto={setRecargaFoto}
            preparaAdeudo={preparaAdeudo}
            nivel={props.nivel}
            muestra={props.muestra ? props.muestra : ""}
          />
          {mostrarNuevo && (
            <NuevoEstudiante
              estudiantes={loadedEstudiantes}
              setLoadedEstudiantes={setLoadedEstudiantes}
              setMostrarNuevo={setMostrarNuevo}
              setDialogoOK={setDialogoOK}
              setMuestraDialogoOK={setMuestraDialogoOK}
              //habitaciones={loadedHabitaciones}
              setRecargar={setRecargar}
              nivel={props.nivel}
            />
          )}
          {mostrarDescuentos && (
            <DescuentoEstudiante
              setMostrarDescuentos={setMostrarDescuentos}
              estudiante={estudiante}
              setDialogoOK={setDialogoOK}
              setMuestraDialogoOK={setMuestraDialogoOK}
              nivel={props.nivel}
              setRecargar={setRecargar}
            />
          )}
          {mostrarPago && (
            <NuevoIngreso
              pagoNuevo={estudiante}
              PagoCompletado={PagoCompletado}
              setMostrarNuevo={setMostrarPago}
              setDialogoOK={setDialogoOK}
              setMuestraDialogoOK={setMuestraDialogoOK}
              nivel={props.nivel}
            />
          )}
          {mostrarElimina && (
            <EliminaEstudiante
              estudiante={estudiante}
              setMostrarElimina={setMostrarElimina}
              EliminadoOK={EliminadoOK}
              setDialogoOK={setDialogoOK}
              setMuestraDialogoOK={setMuestraDialogoOK}
              nivel={props.nivel}
            />
          )}
          {mostrarEdicion && (
            <EditaEstudiante
              estudiante={estudiante}
              setMostrarEdicion={setMostrarEdicion}
              setBorrado={setBorrado}
              setRecargaFoto={setRecargaFoto}
              setDialogoOK={setDialogoOK}
              setMuestraDialogoOK={setMuestraDialogoOK}
              setMostrarElimina={setMostrarElimina}
              nivel={props.nivel}
              setRecargar={setRecargar}
            />
          )}
          {muestraSubMenu && (
            <SubMenuEstudiantes
              posicionSubMenu={posicionSubMenu}
              estudiante={estudiante}
              muestraPagosEstudiante={muestraPagosEstudiante}
              cambiaHabitacion={cambiaHabitacion}
              agregaRecordatorio={agregaRecordatorio}
              nivel={props.nivel}
            />
          )}
          {(mostrarEdicion ||
            mostrarElimina ||
            mostrarPago ||
            mostrarNuevo ||
            mostrarDescuentos ||
            mostrarAgregarRecordatorio) && <Backdrop zindex={9} />}
          {muestraFiltroEst && (
            <MenuFiltraEstudiantes
              posicionFiltroEstudiantes={posFiltroEstudiantes}
              setFiltroEstudiantes={setFiltroEstudiantes}
              filtroEstudiantes={filtroEstudiantes}
              setMuestraFiltroEst={setMuestraFiltroEst}
            />
          )}
          {muestraOrdenaEst && (
            <MenuOrdenaEstudiantes
              posicionOrdenaEstudiantes={posOrdenaEstudiantes}
              setOrdenaEstudiantes={setOrdenaEstudiantes}
              ordenaEstudiantes={ordenaEstudiantes}
              setMuestraOrdenaEst={setMuestraOrdenaEst}
            />
          )}
          {mostrarPagosEstudiante && (
            <PagosEstudiante
              datosPagosEstudiante={datosPagosEstudiante}
              setMostrarPagosEstudiante={() => setMostrarPagosEstudiante(false)}
              borrado={borrado}
              setBorrado={setBorrado}
              setDialogoOK={setDialogoOK}
              setMuestraDialogoOK={setMuestraDialogoOK}
              nivel={props.nivel}
            />
          )}
          {mostrarAgregarRecordatorio && (
            <RecordatorioEstudiante
              datosRecordatorio={datosRecordatorio}
              setMostrarAgregaRecordatorio={() =>
                setMostrarAgregaRecordatorio(false)
              }
              borrado={borrado}
              setMuestraDialogoOK={setMuestraDialogoOK}
              nivel={props.nivel}
            />
          )}
          {mostrarCambiaHabitacion && (
            <CambiaHabitacion
              datosCambiaHabitacion={datosCambiaHabitacion}
              setMostrarCambiaHabitacion={() =>
                setMostrarCambiaHabitacion(false)
              }
              borrado={borrado}
              setBorrado={setBorrado}
              setDialogoOK={setDialogoOK}
              setMuestraDialogoOK={setMuestraDialogoOK}
            />
          )}

          {muestraReactivaEstudiante && (
            <Reactivaestudiante
              setMuestraReactivaEstudiante={setMuestraReactivaEstudiante}
              setDialogoOK={setDialogoOK}
              setMuestraDialogoOK={setMuestraDialogoOK}
              setRecargar={setRecargar}
              nivel={props.nivel}
            />
          )}
          {muestraReactivaEstudiante && (
            <Backdrop recarga={setMuestraReactivaEstudiante} />
          )}
          {mostrarAgregarRecordatorio && (
            <Backdrop recarga={setMostrarAgregaRecordatorio} />
          )}
          {mostrarPagosEstudiante && (
            <Backdrop recarga={setMostrarPagosEstudiante} />
          )}
          {mostrarCambiaHabitacion && (
            <Backdrop recarga={setMostrarCambiaHabitacion} />
          )}
          {muestraOrdenaEst && <Backdrop recarga={setMuestraOrdenaEst} />}
          {muestraFiltroEst && <Backdrop recarga={setMuestraFiltroEst} />}
          {muestraSubMenu && <Backdrop recarga={recarga} />}
          {muestraDialogoOK && (
            <OKModal texto={dialogoOK.texto} oculta={palomeaOK} />
          )}
          {muestraDialogoOK && <Backdrop zindex={49} />}
          {muestraAdeudo && (
            <AdeudoEstudiante
              setMuestraAdeudo={setMuestraAdeudo}
              datosPopAdeudo={datosPopAdeudo}
            />
          )}
          {muestraAdeudo && <Backdrop zindex={9} recarga={setMuestraAdeudo} />}
          {muestraListaNegra && (
            <ListaNegra
              nivel={props.nivel}
              setMuestraListaNegra={setMuestraListaNegra}
              setRecargaFoto={setRecargaFoto}
            />
          )}
          {muestraListaNegra && <Backdrop />}
        </section>
      );
    } else {
      return (
        <section>
          <div className="TituloBoton">
            {props.muestra !== "Adeudo" ? (
              <h1 className="TitEst">No hay estudiantes</h1>
            ) : (
              <h1 className="TitEst">No hay estudiantes con adeudo</h1>
            )}
            <div className="contBotones">
              {props.muestra !== "Adeudo" ? (
                props.nivel === 1 ? (
                  <button className="botAgregaEst" onClick={AgregaEstudiante}>
                    <i className="fas fa-user-plus"></i>
                  </button>
                ) : null
              ) : null}
              {props.muestra !== "Adeudo" ? (
                <button className="botAgregaEst" onClick={setMuestraListaNegra}>
                  <i className="fas fa-ban"></i>
                </button>
              ) : null}
            </div>
          </div>
          {mostrarNuevo && (
            <NuevoEstudiante
              estudiantes={loadedEstudiantes}
              setLoadedEstudiantes={setLoadedEstudiantes}
              setMostrarNuevo={setMostrarNuevo}
              setDialogoOK={setDialogoOK}
              setMuestraDialogoOK={setMuestraDialogoOK}
              setRecargar={setRecargar}
              //habitaciones={loadedHabitaciones}
              nivel={props.nivel}
            />
          )}
          {mostrarNuevo && <Backdrop />}
          {muestraDialogoOK && (
            <OKModal texto={dialogoOK.texto} oculta={palomeaOK} />
          )}
          {muestraDialogoOK && <Backdrop zindex={49} />}
          {muestraListaNegra && (
            <ListaNegra
              nivel={props.nivel}
              setMuestraListaNegra={setMuestraListaNegra}
            />
          )}
          {muestraListaNegra && <Backdrop />}
        </section>
      );
    }
  } else {
    return (
      <section>
        <h1>Primero selecciona la casa</h1>
      </section>
    );
  }
}

export default TodosLosEstudiantesPage;
